import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { requestDatePrice } from '../redux/actions/datePrice';

function DatePriceStatus({ selectedDate, dispatch }) {
  if (selectedDate.priceStatus === 'loading') return <p role="status">Updating the hire price for your date…</p>;
  if (selectedDate.priceStatus !== 'error') return null;
  return <div className="alert alert-danger" role="alert">
    <p>{selectedDate.priceError}</p>
    <button type="button" className="btn btn-primary" onClick={() => dispatch(requestDatePrice(selectedDate.date))}>Retry hire price</button>
  </div>;
}
DatePriceStatus.propTypes = { selectedDate: PropTypes.object.isRequired, dispatch: PropTypes.func.isRequired };
export default connect(state => ({ selectedDate: state.quote.selectedDate }))(DatePriceStatus);
